import { Image, Text, Box, VStack, HStack } from '@chakra-ui/react';

import Card from 'components/card/Card';
import loader from 'assets/img/others/loader.gif';

interface ProcessingStage {
  status: 'pending' | 'in_progress' | 'complete' | 'failed';
  label: string;
}

interface ProcessingCardProps {
  title: string;
  stages?: Record<string, ProcessingStage> | null;
  subtitle?: string;
}

const getStageIcon = (status: string) => {
  if (status === 'complete') return '✓';
  if (status === 'in_progress') return '⟳';
  if (status === 'failed') return '✗';
  return '○';
};

const getStageColor = (status: string) => {
  if (status === 'complete') return 'green.500';
  if (status === 'in_progress') return 'blue.500';
  if (status === 'failed') return 'red.500';
  return 'gray.400';
};

const ProcessingCard = ({ title, stages, subtitle }: ProcessingCardProps) => {
  return (
    <Card>
      <Box textAlign="center">
        <Image src={loader} marginX="auto"></Image>
        <Text fontSize="xl" color="#59606A" mb={subtitle || stages ? 2 : 0}>
          {title}
        </Text>
        {subtitle && (
          <Text fontSize="sm" color="gray.500" mb={stages ? 4 : 0}>
            {subtitle}
          </Text>
        )}
        {stages && (
          <VStack spacing={2} mt={4} align="start" mx="auto" maxW="300px">
            {Object.entries(stages).map(([key, stage]) => (
              <HStack key={key} spacing={2}>
                <Text color={getStageColor(stage.status)} fontWeight="bold">
                  {getStageIcon(stage.status)}
                </Text>
                <Text
                  fontSize="sm"
                  color={
                    stage.status === 'in_progress' ? 'blue.600' : 'gray.600'
                  }
                  fontWeight={stage.status === 'in_progress' ? '500' : 'normal'}
                >
                  {stage.label}
                </Text>
              </HStack>
            ))}
          </VStack>
        )}
      </Box>
    </Card>
  );
};

export default ProcessingCard;
